<template>
	<div class="motion">
		<header class="disable">
            <img src="../assets/image/left.png" alt="" srcset="" class="returnBack">
            <span>下载</span>
        </header>
		 <transition name="fade">
			<div class="toast" v-if="isShow">
				{{msg}}
			</div>
		 </transition>
        <main>
			<div class="btn">
				<button class="btn-get" @click="loadDown">
					<img src="../assets/image/iphone.png" alt="">
					<span>iphone下载</span>
				</button>
				<button class="btn-down" @click="loadDown">
					<img src="../assets/image/android.png" alt="">
					<span>Andriod下载</span>
				</button>
			</div>
        </main>
		
	</div>
</template>
<script>
export default {
	data() {
		return {
			query:{
				userId:0,
				phone:''
			},
			msg:'提示',
			isShow:false
		}
	},
  created() {
	this.query.userId = this.$route.query.userId
	this.userName = this.$route.query.userName
  },
  methods:{
	  loadDown(){
		  if (/(iPhone|iPad|iPod|iOS|OS)/i.test(navigator.userAgent)) {
				// location.href = "itms-apps://itunes.apple.com/app/1257000025";
			//苹果端问
			} else if (/(Android)/i.test(navigator.userAgent)) {
				// location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.qddds.app";
			} 
	  },
  }
}
</script>
<style scoped>
	header {
		width: 100vw;
		height: 44px;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 10;
		background-color: #fff;
		line-height: 44px;
		text-align: center;
		font-size: 16px;
        font-weight:500;
		color:rgba(51,51,51,1);
	}

    .returnBack{
        position: relative;
        width:9px;
        height: 16px;
        float: left;
        top:14px;
        left:20px
    }
    main{
		position: relative;
        height: calc(100vh);
        background-image: url(../assets/image/background.png) ;
		background-size: 100% 100%;
        width:100vw;
		background-clip:content-box;  
		display: flex;
		justify-content: center;
    }

	.btn{
		position: absolute;
		bottom: 80px;
		margin-top:150px;
		text-align: center;
	}
	.btn img{
		width:22px;
		height: 22px;
		vertical-align: center;
	}
	button{
		width:285px;
		height: 49px;
		font-size:16px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(255,255,255,1);
		outline: none;
		border:1px solid rgba(255,255,255,1);
		line-height: 49px;
	}
	.btn-get{
		position: relative;
		background-color: rgb(0, 0, 0,0);
		border-radius:10px;
		text-align: center;
		margin-bottom: 24px;
	}
	.btn-get span{
		position: relative;
		top:-3px;
		left: 10px;
	}
	.btn-down{
		position: relative;
		background-color: rgb(0, 0, 0,0);
		border-radius:10px;
		text-align: center;
	
	}
	.btn-down span{
		position: relative;
		top:-3px;
		left: 10px;
	}
	.toast{
		position: fixed;
		display: flex;
		justify-content: center;
		align-items: center;
		top:50%;
		left:50%;
		/* margin-left: -50px;
		margin-top: -25px; */
		-webkit-transform: translate(-50%,-50%);
		-moz-transform: translate(-50%,-50%);
		transform:translate(-50%,-50%);
		padding:10px;
		background-color: rgba(0, 0, 0, .1);
		z-index: 999999;
		border-radius: 2px;
		color:#998;
		font-size: 14px;
	}
	.fade-enter-active, .fade-leave-active {
		transition: opacity .5s
	}
	.fade-enter, .fade-leave-active {
		opacity: 0
	}


</style>

